module.exports = __webpack_public_path__ + "static/media/signup_image.e71b162d.svg";